import { VerificationPageModel, VerificationPageStatus } from "./verification-page-model";
import completeImage from "../../../assets/images/icon-success-lg.svg";
import verificationImage from "../../../assets/images/simplyhealth_logo.png";

export function updatePageModelForStatusChangeReducer(
  pageModel: VerificationPageModel,
  pageStatus: VerificationPageStatus
): VerificationPageModel {
  let { informationMessages, title, buttonTitle, showButton, subStatus, titleImage } = pageModel;
  titleImage = verificationImage;

  switch (pageStatus) {
    case "Ready":
      title = "Confirm registration";
      buttonTitle = "Continue";
      showButton = true;
      break;
    case "Missing Query Parameters":
      title = "Not Authorised";
      buttonTitle = "";
      informationMessages = ["Unable to determine client application."];
      showButton = false;
      break;
    case "Sending":
      title = "Please wait";
      informationMessages = ["Checking status of your account."];
      break;
    case "Checking Account Status":
      title = "Please wait";
      informationMessages = ["Checking status of your account."];
      showButton = false;
      break;
    case "Succeeded":
      title = "Success";
      informationMessages = ["Your account has been verified."];
      buttonTitle = "Login";
      titleImage = completeImage;
      showButton = true;
      break;
    case "Resend Verification Succeeded":
      title = "Success";
      buttonTitle = "Continue";
      titleImage = completeImage;
      showButton = true;
      break;
    case "Failed":
      title = "Error";
      buttonTitle = "Retry";
      showButton = true;
      break;
  }
  return updatePageModelReducer(pageModel, {
    title,
    titleImage,
    informationMessages,
    buttonTitle,
    subStatus,
    showButton
  });
}

export function updatePageModelReducer(
  pageModel: VerificationPageModel,
  updateModel: Partial<VerificationPageModel>
): VerificationPageModel {
  return { ...pageModel, ...updateModel };
}
